<template>
  <div class="main_view">
    <!--导航栏-->
    <div class="report_head">
      <div class="report_head_item">
        <div class="report_head_left">
          <div class="report_info">
            <a href="/#/" target="_blank">
              <img src="/static/images/bigdata/maoyan_logo.png"/>
            </a>
          </div>
          <div class="line"></div>
          <div class="note">
            <span>AI智能创作演示</span>
          </div>
        </div>
      </div>
    </div>

    <!--功能栏-->
    <el-tabs v-model="activeName" @tab-click="handleClick" class="nav_tab" type="border-card" stretch>
      <el-tab-pane label="AI起标题" name="title">
        <el-input
          v-loading="isActive"
          class="text_view"
          type="textarea"
          placeholder="请输入起标题的产品词，例如：面膜"
          rows="1"
          v-model="title_text_in"
        ></el-input>
        <div class="content_button">
          <el-button class="text_button1" type="warning" @click="submitClear" plain>清空输入</el-button>
          <el-button class="text_button2" type="primary" @click="submitAction">确认提交</el-button>
          <el-button class="text_button3" type="success" @click="submitCopy" plain>复制输出</el-button>
        </div>
        <el-input
          v-loading="isActive"
          class="text_view"
          type="textarea"
          placeholder="点击【确认提交】按钮，结果会显示在这里"
          rows="10"
          v-model="title_text_out"
          :autosize="{minRows: 10, maxRows: 50}"
        >
        </el-input>
      </el-tab-pane>
      <el-tab-pane label="AI出封面" name="image">
        <el-input
          v-loading="isActive"
          class="text_view"
          type="textarea"
          placeholder="请输入封面的产品词，例如：面膜"
          rows="1"
          v-model="image_text_in"
        ></el-input>
        <div class="content_button">
          <el-button class="text_button2" type="primary" @click="submitAction">确认提交</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="AI写内容" name="content">
        <el-input
          v-loading="isActive"
          class="text_view"
          type="textarea"
          placeholder="请输入写内容的描述，例如：面膜的使用步骤"
          rows="1"
          v-model="content_text_in"
        ></el-input>
        <div class="content_button">
          <el-button class="text_button1" type="warning" @click="submitClear" plain>清空输入</el-button>
          <el-button class="text_button2" type="primary" @click="submitAction">确认提交</el-button>
          <el-button class="text_button3" type="success" @click="submitCopy" plain>复制输出</el-button>
        </div>
        <el-input
          v-loading="isActive"
          class="text_view"
          type="textarea"
          placeholder="点击【确认提交】按钮，结果会显示在这里"
          rows="10"
          v-model="content_text_out"
          :autosize="{minRows: 10, maxRows: 50}"
        >
        </el-input>
      </el-tab-pane>
      <el-tab-pane label="敏感词替换" name="word">
        <el-input
          v-loading="isActive"
          class="text_view"
          type="textarea"
          placeholder="请输入要替换的文字"
          rows="10"
          v-model="word_text_in"
          :autosize="{minRows: 10, maxRows: 50}"
        ></el-input>
        <div class="content_button">
          <el-button class="text_button1" type="warning" @click="submitClear" plain>清空输入</el-button>
          <el-button class="text_button2" type="primary" @click="submitAction">确认提交</el-button>
          <el-button class="text_button3" type="success" @click="submitCopy" plain>复制输出</el-button>
        </div>
        <el-input
          v-loading="isActive"
          class="text_view"
          type="textarea"
          placeholder="点击【确认提交】按钮，结果会显示在这里"
          rows="10"
          v-model="word_text_out"
          :autosize="{minRows: 10, maxRows: 50}"
        >
        </el-input>
      </el-tab-pane>
      <el-tab-pane label="表情符号" name="emo">
        <el-input
          class="text_view"
          type="textarea"
          rows="10"
          v-model="emo_text_out"
          :autosize="{minRows: 10, maxRows: 50}"
        >
        </el-input>
      </el-tab-pane>
    </el-tabs>
    <div class="waterfall" v-show="waterfallShow">
      <vue-waterfall-easy
        ref="waterfall"
        :imgsArr="dataList"
        :srcKey="'image'"
        :maxCols="4"
        :gap="10"
        :mobileGap="10"
      >
        <div class="img-info" slot-scope="props">
        </div>
        <div slot="waterfall-over"></div>
      </vue-waterfall-easy>
    </div>
  </div>
</template>

<script>
import process from "shelljs";
import vueWaterfallEasy from 'vue-waterfall-easy'
export default {
  name: "BigdataSensitiveWord",
  components: {
    vueWaterfallEasy
  },
  data() {
    return {
      activeName: 'title',
      waterfallShow: false,
      isActive: false,
      word_text_in: '',
      word_text_out: '',
      content_text_in: '',
      content_text_out: '',
      title_text_in: '',
      title_text_out: '',
      emo_text_out: '',
      image_text_in: '',

      dataList: [], //下拉列表-数据
    }
  },
  methods: {
    handleClick(tab, event) {
      this.waterfallShow = false
      if (tab.name === 'word') {
        this.activeName='word'
      }
      if (tab.name === 'image') {
        this.activeName='image'
        this.waterfallShow = true
      }
      if (tab.name === 'title') {
        this.activeName='title'
      }
      if (tab.name === 'content') {
        this.activeName='content'
      }
      if (tab.name === 'emo') {
        this.activeName='emo'
        this.emo_text_out = '🌹🍀🍎💰📱🌙🍁🍂🍃🌷💎🔪🔫🏀⚽⚡👄👍🔥' +
        '😀😃😄😁😆😅🤣😂🙂🙃😉😊😇🥰😍🤩😘😗😚😙🥲😋😛😜🤪😝🤑🤗🤭🤫🤔🤐🤨😐😑😶😏😒🙄😬🤥😌😔😪🤤😴😷🤒🤕🤢🤮🤧🥵🥶🥴😵🤯🤠🥳🥸😎🤓🧐😕😟🙁️😮😯😲😳🥺😦😧😨😰😥😢😭😱😖😣😞😓😩😫🥱😤😡😠🤬' +
        '👶🧒👦👧🧑👱👨🧔👨‍🦰👨‍🦱👨‍🦳👨‍🦲👩👩‍🦰🧑‍🦰👩‍🦱🧑‍🦱👩‍🦳🧑‍🦳👩‍🦲🧑‍🦲👱‍♀️👱‍♂️🧓👴👵🙍🙍‍♂️🙍‍♀️🙎🙎‍♂️🙎‍♀️🙅🙅‍♂️🙅‍♀️🙆🙆‍♂️🙆‍♀️💁💁‍♂️💁‍♀️🙋🙋‍♂️🙋‍♀️🧏🧏‍♂️🧏‍♀️🙇🙇‍♂️🙇‍♀️🤦🤦‍♂️🤦‍♀️🤷🤷‍♂️🤷‍♀️🧑‍⚕️👨‍⚕️👩‍⚕️🧑‍🎓👨‍🎓👩‍🎓🧑‍🏫👨‍🏫👩‍🏫🧑' +
        '‍⚖️👨‍⚖️👩‍⚖️🧑‍🌾👨‍🌾👩‍🌾🧑‍🍳👨‍🍳👩‍🍳🧑‍🔧👨‍🔧👩‍🔧🧑‍🏭👨‍🏭👩‍🏭🧑‍💼👨‍💼👩‍💼🧑‍🔬👨‍🔬👩‍🔬🧑‍💻👨‍💻👩‍💻🧑‍🎤👨‍🎤👩‍🎤🧑‍🎨👨‍🎨👩‍🎨🧑‍✈️👨‍✈️👩‍✈️🧑‍🚀👨‍🚀👩‍🚀🧑‍🚒👨‍🚒👩‍🚒👮👮‍♂️👮‍♀️🕵️🕵️‍♂️🕵️‍♀️💂💂‍♂️💂‍♀️🥷👷👷‍♂️👷‍♀️🤴👸👳👳‍♂️👳‍♀️👲🧕🤵🤵‍♂️🤵‍♀️👰👰‍♂️👰‍♀️🤰🤱👩‍🍼👨‍🍼🧑‍🍼👼🎅' +
        '🤶🧑‍🎄🦸🦸‍♂️🦸‍♀️🦹🦹‍♂️🦹‍♀️🧙🧙‍♂️🧙‍♀️🧚🧚‍♂️🧚‍♀️🧛🧛‍♂️🧛‍♀️🧜🧜‍♂️🧜‍♀️🧝🧝‍♂️🧝‍♀️🧞🧞‍♂️🧞‍♀️🧟🧟‍♂️🧟‍♀️💆💆‍♂️💆‍♀️💇💇‍♂️💇‍♀️🚶🚶‍♂️🚶‍♀️🧍🧍‍♂️🧍‍♀️🧎🧎‍♂️🧎‍♀️🧑‍🦯👨‍🦯👩‍🦯🧑‍🦼👨‍🦼👩‍🦼🧑‍🦽👨‍🦽👩‍🦽🏃🏃‍♂️🏃‍♀️💃🕺🕴️👯👯‍' +
        '♂️👯‍♀️🧖🧖‍♂️🧖‍♀️🧘🧑‍🤝‍🧑👭👫👬💏👩‍❤️‍💋‍👨👨‍❤️‍💋‍👨👩‍❤️‍💋‍👩💑👩‍❤️‍👨👨‍❤️‍👨👩‍❤️‍👩👪👨‍👩‍👦👨‍👩‍👧👨‍👩‍👧‍👦👨‍👩‍👦‍👦👨‍👩‍👧‍👧👨‍👨‍👦👨‍👨‍👧👨‍👨‍👧‍👦👨‍👨‍👦‍👦👨‍👨‍👧‍👧👩‍👩‍👦👩‍👩‍👧👩‍👩‍👧‍👦👩‍👩‍👦‍👦👩‍👩‍👧‍👧👨‍👦👨‍👦‍👦👨‍👧👨‍👧‍👦👨‍👧‍👧👩‍👦👩‍👦‍👦👩‍👧👩‍👧‍👦👩‍👧‍👧🗣️👤👥🫂' +
        '👋🤚🖐️✋🖖👌🤌🤏✌️🤞🤟🤘🤙👈👉👆🖕👇☝️👍👎✊👊🤛🤜👏🙌👐🤲🤝🙏✍️💅🤳💪🍯🍼🥛☕🫖🍵🍶🍾🍷🍸🍹🍺🍻🥂🥃🥤🧋🧃🧉🧊🥢🍽️🍴🥄' +
        '👣👀👁️👄💋👂🦻👃👅🧠🫀🫁🦷🦴💪🦾🦿🦵🦶👓🕶️🥽🥼🦺👔👕👖🧣🧤🧥🧦👗👘🥻🩱🩲🩳👙👚👛👜👝🎒🩴👞👟🥾🥿👠👡🩰👢👑👒🎩🎓🧢🪖⛑️💄💅💍💼🌂☂️💈🛀🛌💥💫💦💨' +
        '📱📲📶📳📴☎📞📟📠🤳♻🏧🚮🚰♿🚹🚺🚻🚼🚾🚸⛔🚫🚳🚭🚯🚱🚷🔞💈😈👿👹👺💀☠👻👽👾💣🖇️📏📐✂️🗃️🗄️🗑️🔒🔓🔏🔐🔑🗝️' +
        '🙈🙉🙊💥💫💦💨🐵🐒🦍🦧🐶🐕🦮🐕‍🦺🐩🐺🦊🦝🐱🐈🐈‍⬛🦁🐯🐅🐆🐴🐎🦄🦓🦌🦬🐮🐂🐃🐄🐷🐖🐗🐽🐏🐑🐐🐪🐫🦙🦒🐘🦏🦛🐭🐁🐀🐹🐰🐇🐿️🦫🦔🦇🐻🐻‍❄️🐨🐼🦥🦦🦨🦘🦡🐾🦃🐔🐓🐣🐤🐥🐦🐧🕊️🦅🦆🦢🦉🦩🦚🦜🐸🐊🐢🦎🐍🐲' +
        '🐉🦕🦖🐳🐋🐬🦭🐟🐠🐡🦈🐙🐚🐌🦋🐛🐜🐝🪲🐞🦗🪳🕷️🕸️🦂🦟🦠🦀🦞🦐🦑💐🌸💮🏵️🌹🥀🌺🌻🌼🌷🌱🌲🌳🌴🌵🌾🌿☘️🍀🍁🍂🍃' +
        '🌍🌎🌏🌐🪨🌑🌒🌓🌔🌕🌖🌗🌘🌙🌚🌛🌜☀️🌝🌞⭐🌟🌠☁️⛅⛈️🌤️🌥️🌦️🌧️🌨️🌩️🌪️🌫️🌬️🌈☂️☔⚡❄️☃️⛄☄️🔥💧🌊📐✂🔒🔓🔏🔐🔑🔨🔫🔧🔩🔗💉💊🚬🔮🚩🎌💦💨' +
        '🍇🍈🍉🍊🍋🍌🍍🥭🍎🍏🍐🍑🍒🍓🥝🍅🥥🥑🍆🥔🥕🌽🌶️🥒🥬🥦🧄🧅🍄🥜🌰🍞🥐🥖🫓🥨🥯🥞🧇🧀🍖🍗🥩🥓🍔🍟🍕🌭🥪🌮🌯🥙🧆🥚🍳🥘🍲🥣🥗🍿🧈🧂🥫🍱🍘🍙🍚🍛🍜🍝🍠🍢🍣🍤🍥🥮🍡🥟🥠🥡🦪🍦🍧🍨🍩🍪🎂🍰🧁🥧🍫🍬🍭🍮' +
        '🧗🧗‍♂️🧗‍♀️🤺🏇⛷️🏂🏌️🏌️‍♂️🏌️‍♀️🏄🏄‍♂️🏄‍♀️🚣🚣‍♂️🚣‍♀️🏊🏊‍♂️🏊‍♀️⛹️⛹️‍♂️⛹️‍♀️🏋️🏋️‍♂️🏋️‍♀️🚴🚴‍♂️🚴‍♀️🚵🚵‍♂️🚵‍♀️🤸🤸‍♂️🤸‍♀️🤼🤼‍♂️🤼‍♀️🤽🤽‍♂️🤽‍♀️🤾🤾‍♂️🤾‍♀️🤹🤹‍♂️🤹‍♀️🧘🧘‍♂️🧘‍♀️🎪🛹🛼🛶🎗️🎟️🎫🎖️🏆🏅🥇🥈🥉⚽⚾' +
        '🥎🏀🏐🏈🏉🎾🥏🎳🏏🏑🏒🥍🏓🏸🥊🥋🥅⛳⛸️🎣🎽🎿🛷🥌🎯🎱🎮🎰🎲🧩♟️🎭🎨🧵🧶🎼🎤🎧🎷🪗🎸🎹🎺🎻🥁🪘🎬🏹🛤️⛽🚨🚥🚦🚧⚓⛵🚤🛳️⛴️🛥️🚢✈️🛩️🛫🛬🪂💺🚁🚟🚠🚡🛰️🚀🛸🪐🌠🌌⛱️🎆🎇🎑💴💵💶💷🗿🛂🛃🛄🛅🧭' +
        '👣🎠🎡🎢🚣🏔️⛰️🌋🗻🏕️🏖️🏜️🏝️🏞️🏟️🏛️🏗️🛖🏘️🏚️🏠🏡🏢🏣🏤🏥🏦🏨🏩🏪🏫🏬🏭🏯🏰💒🗼🗽⛪🕌🛕🕍⛩🕋⛲⛺🌁🌃🏙️🌄🌅🌆🌇🌉🎠🎡🎢🚂🚃🚄🚅🚆🚇🚈🚉🚊🚝🚞🚋🚌🚍🚎🚐🚑🚒🚓🚔🚕🚖🚗🚘🚙🛻🚚🚛🚜🏎️🏍️🛵🛺🚲🛴🚏🛣️' +
        '💌💎🔪💈🚪🚽🚿🛁⌛⏳⌚⏰🎈🎉🎊🎎🎏🎐🎀🎁📯📻📱📲☎📞📟📠🔋🔌💻💽💾💿📀🎥📺📷📹📼🔍🔎🔬🔭📡💡🔦🏮📔📕📖📗📘📙📚📓📃📜📄📰📑🔖💰💴💵💶💷💸💳✉📧📨📩📤📥📦📫📪📬📭📮✏✒📝📁📂📅📆📇📈📉📊📋📌📍📎📏' +
        '♠️♥️♦️♣️🃏🀄🎴🔇🔈🔉🔊📢📣📯🔔🔕🎵🎶💹🛗🏧🚮🚰♿🚹🚺🚻🚼🚾⚠️🚸⛔🚫🚳🚭🚯🚱🚷📵🔞☢️☣️⬆️↗️➡️↘️⬇️↙️⬅️↖️↕️↔️↩️↪️⤴️⤵️🔃🔄🔙🔚🔛🔜🔝🛐⚛️🕉️✡️☸️☯️✝️☦️☪️☮️🕎🔯♈♉♊♋♌♍♎♏♐♑♒♓⛎🔀🔁🔂▶️⏩⏭️⏯️' +
        '◀️⏪⏮️🔼⏫🔽⏬⏸️⏹️⏺️⏏️🎦🔅🔆📶📳📴♀️♂️✖️➕➖➗♾️‼️⁉️❓❔❕❗〰️💱💲⚕️♻️⚜️🔱📛🔰⭕✅☑️✔️❌❎➰➿ 〽️✳️✴️❇️️#️⃣*️⃣0️⃣1️⃣2️⃣3️⃣4️⃣5️⃣6️⃣7️⃣8️⃣9️⃣🔟🔠🔡🔢🔣🔤🅰️🆎🅱️🆑🆒🆓ℹ️🆔Ⓜ️🆕🆖🅾️🆗🅿️🆘🆙🆚🈁🈂️' +
        '🔴🟠🟡🟢🔵🟣🟤⚫⚪🟥🟧🟨🟩🟦🟪🟫⬛⬜◼️◻️◾◽▪️▫️🔶🔷🔸🔹🔺🔻💠🔘🔳🔲🏁🚩🎌🏴🏳️🏳️‍🌈🏳️‍⚧️🏴‍☠️' +
        '🐁🐂🐅🐇🐉🐍🐎🐐🐒🐓🐕🐖♈♉♊♋♌♍♎♏♐♑♒♓⛎⬆↗➡↘⬇↙⬅↖↕↔↩↪⤴⤵🔃🔄🔙🔚🔛🔜🔝🕛🕧🕐🕜🕑🕝🕒🕞🕓🕟🕔🕠🕕🕡🕖🕢🕗🕣🕘🕤🕙🕥🕚🕦⌛⏳⌚⏰⏱⏲🕰' +
        '💘❤💓💔💕💖💗💙💚💛💜💝💞💟❣💐🌸💮🏵️🌹🥀🌺🌻🌼🌷🌱🌿☘️🍀🌿☘️🍀🍁🍂🍃🌑🌒🌓🌔🌕🌖🌗🌘🌙🌚🌛🌜🌝🍇🍈🍉🍊🍋🍌🍍🍎🍏🍐🍑🍒🍓🥝💴💵💶💷💰💸💳' +
        '🚂🚃🚄🚅🚆🚇🚈🚉🚊🚝🚞🚋🚌🚍🚎🚏🚐🚑🚒🚓🚔🚕🚖🚗🚘🚚🚛🚜🚲⛽🚨🚥🚦🚧⚓⛵🚣🚤🚢✈💺🚁🚟🚠🚡🚀🏟️🏛️🏗️🛖🏘️🏚️🏠🏡🏢🏣🏤🏥🏦🏨🏩🏪🏫🏬🏭🏯🏰💒🗼🗽⛪🕌🛕🕍⛩️🕋⛲⛺🌁🌃🏙️🌄🌅🌆🌇🌉' +
        '📱📲☎️📞📟📠🔋🔌💻🖥️🖨️⌨️🖱️🖲️💽💾💿📀🧮🎥🎞️📽️📺📷📸📹📼🔍🔎🕯️💡🔦🏮🪔📔📕📖📗📘📙📚📓📒📃📜📄📰🗞️📑🔖🏷️💰🪙💴💵💶💷💸💳🧾✉️📧📨📩📤📥📦📫📪📬📭📮🗳️✏️✒️🖋️🖊️🖌️🖍️📝📁📂🗂️📅📆🗒️🗓️📇📈📉📊📋📌📍📎'
      }
    },
    submitAction() {
      if (this.activeName === 'word') {
        if (!this.word_text_in) {
          return this.$message({
            type: "error",
            message: "请输入内容",
          })
        }
        this.submitWordAction()
      }
      if (this.activeName === 'image') {
        this.submitImgAction('image')
      }
      if (this.activeName === 'title') {
        if (!this.title_text_in) {
          return this.$message({
            type: "error",
            message: "请输入内容",
          })
        }
        this.submitAiAction('title')
      }
      if (this.activeName === 'content') {
        if (!this.content_text_in) {
          return this.$message({
            type: "error",
            message: "请输入内容",
          })
        }
        this.submitAiAction('content')
      }
    },
    submitImgAction(ctype) {
      this.isActive = true
      let base = '/api'
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com'
      }
      let url = '/api/v2/maocep/maocep_vue_xhs_ai_create'
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'content': this.image_text_in,
          'ctype': ctype,
        })
      }).then((res) => {
        this.isActive = false
        if (res.data.error===1) {
          return this.$message({
            type: "error",
            message: res.data.message,
          })
        }
        this.dataList = res.data.result
        // 不上拉加载更多了
        this.$refs.waterfall.waterfallOver()
      }).catch((res) => {
        this.isActive = false
      })
    },
    submitAiAction(ctype) {
      this.isActive = true
      let content = this.title_text_in
      if (this.activeName === 'content') {
        content = this.content_text_in
      }
      let base = '/api'
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com'
      }
      let url = '/api/v2/maocep/maocep_vue_xhs_ai_create'
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'content': content,
          'ctype': ctype,
        })
      }).then((res) => {
        this.isActive = false
        if (res.data.error===1) {
          return this.$message({
            type: "error",
            message: res.data.message,
          })
        }
        if (this.activeName === 'content') {
          this.content_text_out = res.data.result
        } else {
          this.title_text_out = res.data.result
        }
      }).catch((res) => {
        this.isActive = false
      })
    },
    submitWordAction() {
      this.isActive = true
      let base = '/api'
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com'
      }
      let url = '/api/v2/maocep/maocep_vue_xhs_exp_content'
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'content': this.word_text_in,
        })
      }).then((res) => {
        this.isActive = false
        if (res.data.error===1) {
          return this.$message({
            type: "error",
            message: res.data.message,
          })
        }
        this.word_text_out = res.data.result
      }).catch((res) => {
        this.isActive = false
      })
    },
    submitClear() {
      this.isActive = false
      if (this.activeName === 'word') {
        this.word_text_in=''
        this.word_text_out=''
      }
      if (this.activeName === 'title') {
        this.title_text_in=''
        this.title_text_out=''
      }
      if (this.activeName === 'content') {
        this.content_text_in=''
        this.content_text_out=''
      }
      this.$message({
        message: '清空成功',
        type: 'success'
      })
    },
    submitCopy() {
      this.isActive = false
      if (this.activeName === 'word') {
        if (!this.word_text_out) {
          return this.$message({
            type: "error",
            message: "内容不能为空",
          })
        }
        let input = document.createElement("input"); // 创建input对象
        input.value = this.word_text_out  // 设置复制内容
        document.body.appendChild(input) // 添加临时实例
        input.select() // 选择实例内容
        document.execCommand("Copy") // 执行复制
        document.body.removeChild(input) // 删除临时实例
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      }
      if (this.activeName === 'title') {
        if (!this.title_text_out) {
          return this.$message({
            type: "error",
            message: "内容不能为空",
          })
        }
        let input = document.createElement("input"); // 创建input对象
        input.value = this.title_text_out  // 设置复制内容
        document.body.appendChild(input) // 添加临时实例
        input.select() // 选择实例内容
        document.execCommand("Copy") // 执行复制
        document.body.removeChild(input) // 删除临时实例
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      }
      if (this.activeName === 'content') {
        if (!this.content_text_out) {
          return this.$message({
            type: "error",
            message: "内容不能为空",
          })
        }
        let input = document.createElement("input"); // 创建input对象
        input.value = this.content_text_out  // 设置复制内容
        document.body.appendChild(input) // 添加临时实例
        input.select() // 选择实例内容
        document.execCommand("Copy") // 执行复制
        document.body.removeChild(input) // 删除临时实例
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      }

    },
  },
  mounted: {
  },
  metaInfo: {
    title: "袤-AI智能创作平台",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'

.main_view
  display flex
  align-items center
  justify-content center
  flex-direction column
  width 100%
  //background-color $brand-bgm
  background-color  white

  .report_head
    left 0
    top 0
    width 100%
    z-index 1
    background-color $white
    height 75px
    box-shadow 0 1px 8px 0 rgba(0,0,0,0.1)
    .report_head_item
      margin-left 5%
      margin-right 5%
      width 90%
      height 75px
      display flex
      flex-direction row
      align-items center
      justify-content space-between
      .report_head_left
        width auto
        display flex
        flex-direction row
        align-items center
        height auto
        .report_info
          width 180px
          height auto
          display flex
          flex-direction column
          span
            margin-top 5px
            font-size 12px
            color $brand-gray
          img
            width auto
            height auto
        .line
          margin-left 10px
          width 1px
          height 57px
          background-color $colorE
        .note
          font-weight bold
          font-size 20px
          margin-left 15px
          color $color-two
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center



  .nav_tab
    width 100%
    background-color $white

    .text_view
      margin-top 35px
      margin-bottom 15px
      margin-left 5%
      margin-right 5%
      width 90%

    .content_button
      display flex
      align-items center
      justify-content center
      margin-top 15px
      margin-bottom 15px
      margin-left 5%
      margin-right 5%
      width 90%

  .waterfall {
    background-color $white
    width 100%
    height 1000px
  }

/deep/ .vue-waterfall-easy-container {
  .img-inner-box {
    border-radius  5px !important
    background-color  white !important
    box-shadow  none !important
    .img-wraper > img {
      border-radius  5px !important
    }
  }
}


/deep/ .el-tabs
  margin-top 0
  margin-bottom 0
  box-shadow none !important
  border solid #DCDFE6 !important
  border-top-width 1px !important
  border-right-width 0 !important
  border-bottom-width 0 !important
  border-left-width 0 !important
  .el-tabs__header
    margin 0 !important

</style>



// WEBPACK FOOTER //
// src/components/bigdata/BigdataSensitiveWord.vue